import axios from 'axios';
import { API } from '@/lib/api';

// Separate axios instance for photographer-side calls.
// Uses photographer_token (issued by /photographer/auth/verify-magic-link).
const photoApi = axios.create({ baseURL: API });

photoApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('photographer_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

photoApi.interceptors.response.use(
  (r) => r,
  (error) => {
    const status = error.response?.status;
    if (status === 401) {
      localStorage.removeItem('photographer_token');
      localStorage.removeItem('photographer');
      if (typeof window !== 'undefined' && !window.location.pathname.startsWith('/photographer/login')) {
        window.location.href = '/photographer/login';
      }
    }
    return Promise.reject(error);
  }
);

export default photoApi;
